import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { Center } from "src/app/models/centers/center";
import { Filter, getAllChildren } from "src/app/models/settings/filter-setting";
import { CenterService } from "src/app/services/center/center.service";
import { SettingService } from "src/app/services/setting/setting.service";

@Component({
  selector: "app-center-detail",
  templateUrl: "./center-detail.component.html",
  styleUrls: ["./center-detail.component.scss"],
})
export class CenterDetailComponent implements OnInit, AfterViewInit {
  @Input() beforeClose!: Function;
  @ViewChild("image") _image!: ElementRef;
  image: HTMLElement = this._image?.nativeElement as HTMLElement;
  display: boolean = false;
  loading: boolean = false;
  regions!: Filter;

  uuId: string = "";
  centerCode: string = "";
  name: string = "";
  phoneNumber: string = "";
  wts: boolean = false;
  wts_num: string = "";
  service_Time: string = "";
  file: any;
  newIcon: boolean = false;
  oldIcon: string = "";
  logoFile: File | null = null;
  filters: Filter[] = [];
  blockedFilters: Filter[] = [];

  constructor(
    private centerService: CenterService,
    private settingService: SettingService,
  ) {}

  ngOnInit(): void {
    this.settingService
      .getFilter(1)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (value) => {
          if (value.filter) this.regions = value.filter;
        },
      });
  }

  ngAfterViewInit(): void {
    if (this.image) {
      this.image.onerror = () => {
        this.newIcon = false;
        this.logoFile = null;
      };
    }
  }

  get oldIconTxt() {
    return this.oldIcon != ""
      ? this.oldIcon.substring(this.oldIcon.lastIndexOf("/") + 1)
      : "";
  }

  update(center: Center, centers: Center[]) {
    // this is the actual function that gets called when the popup is shown
    this.display = true;
    this.newIcon = false;
    this.logoFile = null;
    this.oldIcon = "";
    this.uuId = center.uuId;
    this.centerCode = center.centerCode;
    this.phoneNumber = center.phoneNumber;
    this.name = center.name;
    this.file = null;
    if (center.otherContactInfo && typeof center.otherContactInfo == "object") {
      this.wts = center.otherContactInfo.wts
        ? center.otherContactInfo.wts
        : false;
      this.wts_num = center.otherContactInfo.wts_num
        ? center.otherContactInfo.wts_num
        : "";
      this.service_Time = center.otherContactInfo.service_Time
        ? center.otherContactInfo.service_Time
        : "";
      //="/api/center/icon?OrgCode="+localStorage.getItem("OrgCode")+"&CenterCode="+this.centerCode;
      this.oldIcon = center.otherContactInfo.icon
        ? center.otherContactInfo.icon
        : "";
      this.centerService.getCenterImage(this.centerCode).subscribe({
        next: (result) => {
          var reader = new FileReader();
          reader.readAsDataURL(result);
          var _this = this;
          reader.onloadend = function () {
            _this.file = reader.result;
          };
        },
        error: (error) => {
          //Do Nothing
          this.file = null;
        },
      });
    }
    this.filters = getAllChildren(center.filters);
    this.blockedFilters = [];
    centers
      .filter((c) => c.uuId != center.uuId)
      .forEach((c) =>
        c.filters.forEach((f) => {
          if (!this.blockedFilters.find((bf) => bf.id == f.id))
            this.blockedFilters.push(f);
        }),
      );
  }

  close() {
    if (this.beforeClose != null) this.beforeClose();
    this.display = false;
  }

  save() {
    this.loading = true;

    var formData: FormData = new FormData();

    formData.append("uuId", this.uuId);
    formData.append("name", this.name);
    formData.append("centerCode", this.centerCode);
    formData.append("phoneNumber", this.phoneNumber);
    if (this.newIcon && this.logoFile) {
      formData.append(
        "OtherContactInfo",
        JSON.stringify({
          wts: this.wts,
          wts_num: this.wts_num,
          service_Time: this.service_Time,
        }),
      );
      formData.append("icon", this.logoFile);
    } else {
      formData.append(
        "OtherContactInfo",
        JSON.stringify({
          wts: this.wts,
          wts_num: this.wts_num,
          service_Time: this.service_Time,
          icon: this.oldIcon,
        }),
      );
    }

    this.filters.forEach((f) => formData.append("filters", `${f.id}`));

    this.centerService
      .updateCenter(formData)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.close();
        },
      });
  }

  public onImageImport(files: FileList): void {
    this.processLogoImage(files[0]).subscribe({
      next: (response) => {
        this.file = response;
        this.newIcon = true;
      },
      complete: () => {},
    });
  }

  private processLogoImage(logo: File): Observable<any> {
    this.logoFile = logo;
    return new Observable((subscriber) => {
      if (logo == null) {
        subscriber.complete();
        return;
      }
      var fileReader: FileReader = new FileReader();
      fileReader.onload = function (e) {
        subscriber.next(e.target?.result);
      };
      fileReader.readAsDataURL(logo);
    });
  }

  public parse(json: string): any {
    return JSON.parse(json);
  }
  public selectedDistrict(id: number) {
    return this.filters.find((f) => f.id == id);
  }
  public changeDistrict(filter: Filter, state: boolean) {
    if (state && !this.filters.find((f) => f.id == filter.id)) {
      this.filters.push(filter);
    }
    if (!state) {
      let idx = this.filters.findIndex((f) => f.id == filter.id);
      if (idx) this.filters.splice(idx, 1);
    }
  }
  public blockedDistrict(id: number) {
    return this.blockedFilters.find((bf) => bf.id == id);
  }
}
